export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-problem-2.8b50ab1f.png";